import { h, Component } from 'preact'
import { Router } from 'preact-router'

import Authentication from './routes/authentication'
import LinkFbb from './routes/linkFbb'
import AuthenticationFBB from './routes/authenticationFBB'
import AuthenticationFBBFirstRegister from './routes/authenticationFBBFirstRegister'
import ErrorPages from './routes/errorPage'
import Questions from './routes/questions'
import RedirectUrl from './routes/redirectUrl'
import AuthorizeUrl from './routes/authorizeUrl'

import Form from '../src/routes/form'
import TrackDocument from '../src/routes/trackDocument'
import DocumentDetail from '../src/routes/documentDetail'
import FibreForm from '../src/routes/fibreForm'
import FibreTrackDocument from '../src/routes/fibreTrackDocument'
import FibreDocumentDetail from '../src/routes/fibreDocumentDetail'
import FibrePushMessage from './routes/fibrePushMessage'
import SettingPrivilege from './routes/settingPrivilege'
import { authService } from './service/oAuth'
export default class App extends Component {
  /** Gets fired when the route changes.
   *	@param {Object} event		"change" event from [preact-router](http://git.io/preact-router)
   *	@param {string} event.url	The newly routed URL
   */

  handleRoute = (e) => {
    this.currentUrl = e.url
  }

  componentDidMount = async () => {
    if (
      [
        `/fibre/push-message`,
        `/fibre/document-detail`,
        `/fibre/track-document`,
        `/fibre/form-document`,
        `/form-document`,
        `/track-document`,
        `/document-detail`,
      ].includes(window.location.pathname)
    ) {
    } else {
      await this.getToken()
    }
  }

  getToken = async () => {
    try {
  
      if (
        [
          `/line/redirect`,
          `/line/fibre/registered`,
          `/line/fibre/setting`,
          '/line/authorize',
          `/line/privilege/setting`,
        ].includes(window.location.pathname)
      ) {
        return;
      }
  
      const urlParams = new URLSearchParams(window.location.search);
      const query = urlParams.get('q');
      let token = authService.getAccessToken();  

      // 🔹 ถ้าไม่มี Token -> ขอ Token ใหม่
      if (!token) {
        try {
          return await authService.generateToken();
        } catch (error) {
          console.error('Failed to generate token:', error);
          window.location.replace('/error');
          return;
        }
      }
  
      // 🔹 ตรวจสอบว่า Token หมดอายุหรือไม่
      if (authService.isTokenExpired(token)) {
  
        try {
          await authService.refreshToken();
          token = authService.getAccessToken(); // ✅ ใช้ Token ใหม่ที่รีเฟรชมา
        } catch (error) {
          console.error('Failed to refresh token, redirecting to /error');
          authService.removeToken();
          window.location.replace('/error');
          return;
        }
      }
  
      if (!query && window.location.pathname !== '/error') {
        window.location.replace('/error');
      }
  
    } catch (error) {
      console.error('Unexpected error in getToken:', error);
      window.location.replace('/error');
    }
  };

  render() {
    return (
      <div id="app">
        <Router onChange={this.handleRoute}>
          <RedirectUrl path="/line/redirect" />
          <AuthorizeUrl path="/line/authorize" />
          <AuthenticationFBBFirstRegister path="/line/fibre/linking" />
          <LinkFbb path="/line/fibre/registered" />
          <LinkFbb path="/line/fibre/setting" />
          <SettingPrivilege path="/line/privilege/setting" />
          <AuthenticationFBB path="/line/fibre/:name" />
          <Authentication path="/line/:name" />
          <Questions path="/line/:name/questions" />
          <ErrorPages path="/error" />
          <Form path="/form-document" />
          <TrackDocument path="/track-document" />
          <DocumentDetail path="/document-detail" />
          <FibreForm path="/fibre/form-document" />
          <FibreTrackDocument path="/fibre/track-document" />
          <FibreDocumentDetail path="/fibre/document-detail" />
          <FibrePushMessage path="/fibre/push-message" />
        </Router>
      </div>
    )
  }
}
